import * as React from "react";
type Props = {
  className?: string,
};
function SvgOrganic3({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-organic3"
      className={className}
    >
      <path
        d="M19.9713 4.84283C19.9229 4.34985 19.5044 3.98068 19.0027 4.00078C16.0366 4.11912 13.7457 5.08636 12.1964 6.876C11.6805 7.47167 11.2954 8.11121 10.9999 8.75108C10.7043 8.11104 10.3192 7.47139 9.80321 6.87554C8.25343 5.08636 5.96349 4.11912 2.99735 4.00078C2.49523 3.98251 2.07808 4.35076 2.02874 4.84283C2.01138 5.01737 1.63353 9.14675 4.22685 11.9818C5.62351 13.5086 7.58825 14.3417 10.0641 14.4799V18.7428H11.9355V14.4799C14.4113 14.3417 16.3757 13.5086 17.7728 11.9818C20.3661 9.14675 19.9887 5.01737 19.9713 4.84283ZM5.6158 10.7276C4.23096 9.22077 3.93169 7.13277 3.88189 5.94668C5.83419 6.1829 7.34422 6.90159 8.37862 8.08905C9.6771 9.5808 9.96494 11.5112 10.0147 12.6095C8.1191 12.4752 6.64197 11.8442 5.6158 10.7276ZM11.9817 12.6095C12.0283 11.518 12.3115 9.60182 13.6114 8.10093C14.6458 6.90661 16.159 6.18381 18.1182 5.94668C18.0679 7.13277 17.7682 9.22077 16.3838 10.7276C15.3567 11.8447 13.8791 12.4761 11.9817 12.6095Z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgOrganic3;
